import {isAssignedTickets} from '@wix/wix-events-commons-statics'
import {useEnvironment, useTranslation} from '@wix/yoshi-flow-editor'
import classNames from 'classnames'
import React, {useEffect} from 'react'
import {FormStep} from '../../../constants'
import {useAppActions, useAppSelector} from '../../../hooks/runtime'
import {getEvent} from '../../../selectors/event'
import {getNavigationQuery} from '../../../selectors/navigation'
import {getReservationExpiration} from '../../../selectors/reservation'
import c from '../../classnames.scss'
import {FormSteps} from '../../form-steps'
import {Step} from '../../form-steps/interfaces'
import {RegistrationLayout} from '../../registration-layout'
import {Summary} from '../../summary'
import {useCheckoutCacheListener} from '../hooks/use-checkout-cache-listener'
import {Checkout} from '../index'
import {ReservationTimer} from '../reservation-timer'

export const DesktopCheckout = () => {
  const {isMobile} = useEnvironment()
  const {t} = useTranslation()
  const {openTimeExpiredModal, formPageLoaded, closeNativeModal, scrollToElement, getCheckoutData, navigateBack} =
    useAppActions()

  const event = useAppSelector(getEvent)
  const reservationExpiration = useAppSelector(getReservationExpiration)
  const query = useAppSelector(getNavigationQuery)

  useCheckoutCacheListener()

  useEffect(() => {
    formPageLoaded(true)
    closeNativeModal()

    if (isAssignedTickets(event) && query?.orderNumber) {
      navigateBack()
    }

    if (query?.reservationId) {
      getCheckoutData({eventId: event.id, reservationId: query.reservationId, orderNumber: query.orderNumber})
    }
  }, [])

  return (
    <Checkout isMobile={isMobile}>
      {(steps: Step[], currentStep: FormStep) => (
        <div className={classNames(c.formBackgroundColor)}>
          <RegistrationLayout
            Left={<FormSteps currentStep={currentStep} steps={steps} t={t} scrollToElement={scrollToElement} />}
            Right={
              <>
                <ReservationTimer
                  expires={reservationExpiration}
                  onExpire={openTimeExpiredModal}
                  t={t}
                  isMobile={isMobile}
                />
                <Summary currentStep={currentStep} />
              </>
            }
          />
        </div>
      )}
    </Checkout>
  )
}
